var _path, _path2, _path3;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgImageUploadIcon(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 20,
    height: 20,
    viewBox: "0 0 20 20",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M13.5852 2.2915H6.37518C3.86518 2.2915 2.29102 4.06984 2.29102 6.5865V13.3748C2.29102 15.8915 3.85852 17.6698 6.37518 17.6698H13.581C16.1018 17.6698 17.6685 15.8915 17.6685 13.3748V6.5865C17.6718 4.06984 16.1043 2.2915 13.5852 2.2915Z",
    stroke: "#313131",
    strokeWidth: 1.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M8.91846 7.32083C8.91846 8.17083 8.23013 8.85917 7.38013 8.85917C6.53096 8.85917 5.8418 8.17083 5.8418 7.32083C5.8418 6.47083 6.53096 5.7825 7.38013 5.7825C8.2293 5.78333 8.91763 6.47167 8.91846 7.32083Z",
    stroke: "#313131",
    strokeWidth: 1.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M17.6725 12.4592C16.9033 11.6675 15.4242 10.0683 13.8158 10.0683C12.2067 10.0683 11.2792 13.5958 9.73167 13.5958C8.18417 13.5958 6.77833 12.0008 5.53833 13.0233C4.29833 14.045 3.125 16.1342 3.125 16.1342",
    stroke: "#313131",
    strokeWidth: 1.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgImageUploadIcon);
export default __webpack_public_path__ + "static/media/image-upload-icon.e1db4f3a219ce5be62140e7ed0170662.svg";
export { ForwardRef as ReactComponent };